import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Modal } from '../Modal';
import { log } from '../../utils/logger';
import './Anketa.css';

export const ConfirmEmailPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [endpointAddress, setEndpointAddress] = useState<string>('');
    const [loading, setLoading] = useState(true);
    const [confirmed, setConfirmed] = useState(false);
    const [modal, setModal] = useState<{ open: boolean; type: "success" | "error"; text: string }>({ 
        open: false, 
        type: "success", 
        text: "" 
    });

    useEffect(() => {
        fetch('/config.json')
            .then(res => res.json())
            .then(config => {
                if (config['endpoint-address']) {
                    setEndpointAddress(config['endpoint-address']);
                }
                log('ConfirmEmail', 'Загружен config', { hasEndpoint: !!config['endpoint-address'] });
            })
            .catch(err => log('ConfirmEmail', 'Ошибка загрузки config', err));
    }, []);

    useEffect(() => {
        // Получаем id и token из query параметров URL
        const id = searchParams.get('id');
        const token = searchParams.get('token');

        log('ConfirmEmail', 'Query параметры', { id: !!id, token: !!token });

        if (!id || !token) {
            setModal({
                open: true,
                type: "error",
                text: "Отсутствуют необходимые параметры в ссылке."
            });
            setLoading(false);
            return;
        }

        if (!endpointAddress) {
            // Ждем загрузки endpoint
            return;
        }

        // Отправляем POST запрос с id и token из query параметров
        const confirmAccount = async () => {
            try {
                const requestBody = { id, token };
                log('ConfirmEmail', 'Отправка подтверждения', { url: `${endpointAddress}/confirmAccount` });

                const response = await fetch(`${endpointAddress}/confirmAccount`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody)
                });

                const data = await response.json().catch(() => ({}));

                if (!response.ok) {
                    throw new Error(data.message || `Ошибка сервера: ${response.status}`);
                }

                // Сохраняем id и token в localStorage (из ответа или из запроса)
                const savedId = data.id ?? id;
                const savedToken = data.token ?? token;
                localStorage.setItem('id', String(savedId));
                localStorage.setItem('token', String(savedToken));

                log('ConfirmEmail', 'Почта подтверждена, id/token сохранены');
                setConfirmed(true);
            } catch (error: unknown) {
                log('ConfirmEmail', 'Ошибка подтверждения', error);
                const message = error instanceof Error ? error.message : 'Не удалось подтвердить электронную почту. Попробуйте позже.';
                setModal({
                    open: true,
                    type: "error",
                    text: message
                });
            } finally {
                setLoading(false);
            }
        };

        confirmAccount();
    }, [searchParams, endpointAddress]);

    const closeModal = () => {
        setModal({ ...modal, open: false });
        if (modal.type === "success") {
            navigate("/");
        }
    };

    if (loading) {
        return (
            <div className="anketa-container">
                <div className="register-card">
                    <div className="question-section">
                        <h2 className="question-text">Подтверждение...</h2>
                        <p className="question-hint">Пожалуйста, подождите</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="anketa-container">
            <Modal
                isOpen={modal.open}
                onClose={closeModal}
                title={modal.type === "success" ? "Успешно" : "Ошибка"}
                type={modal.type}
            >
                <p>{modal.text}</p>
            </Modal>
            <div className="register-card">
                <div className="question-section">
                    {confirmed ? (
                        <>
                            <h2 className="question-text" style={{ color: 'var(--success)' }}>
                                Ваш адрес электронной почты подтвержден!
                            </h2>
                            <p className="question-hint">
                                Вы можете закрыть эту страницу или перейти на главную.
                            </p>
                        </>
                    ) : (
                        <>
                            <h2 className="question-text">Ошибка подтверждения</h2>
                            <p className="question-hint">
                                Не удалось подтвердить адрес электронной почты.
                            </p>
                        </>
                    )}
                </div>

                <div className="navigation-section" style={{ justifyContent: "center", flexWrap: "wrap", gap: "0.75rem" }}>
                    {confirmed && (
                        <button 
                            className="nav-btn submit-btn" 
                            onClick={() => {
                                login();
                                navigate("/");
                            }}
                        >
                            На главную страницу пользователя
                        </button>
                    )}
                    <button 
                        className="nav-btn prev-btn" 
                        onClick={() => navigate("/")}
                    >
                        На главную
                    </button>
                </div>
            </div>
        </div>
    );
};
